import { AUCTION_EVENTS } from "../../event_bus_modules/auction_bidding";

const $loaderLayer = $('#sidebar-content .loader-layer');

const showLoaderLayer = () => {
    $loaderLayer.addClass('loader-layer--active');
}

const hideLoaderLayer = () => {
    $loaderLayer.removeClass('loader-layer--active');
}

EVENT_BUS.on(AUCTION_EVENTS.AUCTION_TIME_ENDED, () => {
    showLoaderLayer();
});

EVENT_BUS.on(AUCTION_EVENTS.AUCTION_STATUS_UPDATED, ({secondsToClosing}) => {
    if (secondsToClosing > 0) {
        hideLoaderLayer();
    }
})

EVENT_BUS.on(AUCTION_EVENTS.AUCTION_CLOSED, () => {
    hideLoaderLayer();
})
